import { useMutation, UseMutationOptions, useQueryClient } from "react-query";

import { ApiError, PantryService, BooleanResponse } from "../api/public";

type Request = {
  rawMaterialId: string;
  organizationId?: string;
};

export const useAddToPantryMutation = (
  options?: UseMutationOptions<BooleanResponse, ApiError, Request>
) => {
  const queryClient = useQueryClient();
  return useMutation<BooleanResponse, ApiError, Request>(
    async ({ rawMaterialId, organizationId }: Request) => {
      return PantryService.pantryAddToUserPantry(rawMaterialId, organizationId);
    },
    {
      ...options,
      onSuccess: (
        data: BooleanResponse,
        variables: Request,
        context: unknown
      ) => {
        queryClient.invalidateQueries("pantry");
        queryClient.invalidateQueries("pantryIds");
        options?.onSuccess?.(data, variables, context);
      },
    }
  );
};
